import React from 'react';
import SettingsLayout from './SettingsLayout';

const TermsOfServicePage = () => {
  return (
    <SettingsLayout
      title="Terms of Service"
      subtitle="Last updated: January 2025"
    >
      <div className="bg-white rounded-3xl border border-gray-100 p-6 space-y-6 text-sm text-gray-700 leading-relaxed">
        <section>
          <h2 className="font-serif font-bold text-gray-900 text-base mb-2">
            1. Acceptance
          </h2>
          <p>
            By creating a Skytone account and using our services, you agree to these
            terms. If you don't agree, please don't use Skytone.
          </p>
        </section>

        <section>
          <h2 className="font-serif font-bold text-gray-900 text-base mb-2">
            2. Your account
          </h2>
          <p>
            You're responsible for keeping your login details secure. You must be at
            least 18 years old, or have permission from a parent or guardian, to use
            Skytone.
          </p>
        </section>

        <section>
          <h2 className="font-serif font-bold text-gray-900 text-base mb-2">
            3. Bookings and orders
          </h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>
              A booking is a request — it's confirmed only when the professional
              accepts it.
            </li>
            <li>
              Payment terms (deposit, full upfront, or after service) are set by each
              professional and shown clearly before you confirm.
            </li>
            <li>
              Cancellations may be subject to the professional's cancellation policy.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="font-serif font-bold text-gray-900 text-base mb-2">
            4. Payments
          </h2>
          <p>
            Card payments are processed securely by Paystack. We never see or store
            your card details. PayShap and cash payments are between you and the
            professional.
          </p>
        </section>

        <section>
          <h2 className="font-serif font-bold text-gray-900 text-base mb-2">
            5. Behaviour
          </h2>
          <p>
            You agree not to:
          </p>
          <ul className="list-disc pl-5 space-y-1 mt-1">
            <li>Harass, abuse, or threaten other users or professionals.</li>
            <li>Post false, misleading, or offensive content.</li>
            <li>Attempt to bypass security or access accounts you don't own.</li>
            <li>Use Skytone for illegal activity.</li>
          </ul>
          <p className="mt-2">
            We may suspend or remove accounts that break these rules.
          </p>
        </section>

        <section>
          <h2 className="font-serif font-bold text-gray-900 text-base mb-2">
            6. For professionals
          </h2>
          <p>
            If you sell services or products on Skytone, you must provide accurate
            information, honor confirmed bookings, and comply with South African
            consumer protection laws.
          </p>
        </section>

        <section>
          <h2 className="font-serif font-bold text-gray-900 text-base mb-2">
            7. Liability
          </h2>
          <p>
            Skytone is a platform that connects clients with independent professionals.
            We are not a party to the agreements between them and are not responsible
            for the quality of services or products delivered.
          </p>
        </section>

        <section>
          <h2 className="font-serif font-bold text-gray-900 text-base mb-2">
            8. Changes
          </h2>
          <p>
            We may update these terms occasionally. When we do, we'll notify you by
            email or in the app before they take effect.
          </p>
        </section>

        <section>
          <h2 className="font-serif font-bold text-gray-900 text-base mb-2">
            9. Contact
          </h2>
          <p>
            Questions? Email{' '}
            <a href="mailto:support@skytone.app" className="font-bold text-[#EFA9B6] underline">
              support@skytone.app
            </a>.
          </p>
        </section>
      </div>
    </SettingsLayout>
  );
};

export default TermsOfServicePage;